export default __webpack_public_path__ + "static/media/reports_white.d7729bf2.svg";